import styled from 'styled-components'

import { theme } from 'styles/theme'

import { CARD_GAP, fluidType } from '../fluid-type'

const { colors, media, space } = theme

export { Section } from 'components/general-styles/General'

export const TitleWrapper = styled.div`
  h2 {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    letter-spacing: -0.02em;
  }
`

/* O card dos selos é bem mais largo que o de dúvidas, como no desenho. */
export const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-md']};
  margin-top: ${space['spacing-xl']};

  @media (${media.desktop}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 2.2fr);
    align-items: stretch;
    gap: ${CARD_GAP};
    margin-top: 3.125rem;
  }
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${space['spacing-lg']} ${space['spacing-md']};
  overflow: hidden;

  /* 20px do desenho: a escala de raio pula de 16px para 24px. */
  border-radius: 1.25rem;

  p {
    margin: 0;
  }
`

export const DoubtsCard = styled(Card)`
  gap: ${space['spacing-xl']};
  background-color: ${colors['blue-background-strong-default']};

  @media (${media.desktop}) {
    padding: 1.875rem ${space['spacing-xl']};
  }
`

export const SealsCard = styled(Card)`
  gap: ${space['spacing-lg']};
  background-color: ${colors['neutral-background-default']};

  @media (${media.desktop}) {
    justify-content: center;
    padding: 1.875rem 3.125rem;
  }
`

export const Mail = styled.a`
  color: ${colors['neutral-text-contrast-default']};
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`

/* As barras entre os selos são bordas, não SVG. */
export const Seals = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space['spacing-xl']};

  @media (${media.desktop}) {
    gap: 3.75rem;
    flex-wrap: nowrap;
  }
`

export const Seal = styled.div`
  display: flex;
  align-items: center;

  img {
    width: auto;
    max-width: 100%;
    max-height: 5.5rem;
  }

  &:not(:last-child)::after {
    content: '';
    width: 1px;
    height: 2.75rem;
    margin-left: ${space['spacing-xl']};
    background-color: ${colors['neutral-background-strong']};
  }

  @media (${media.desktop}) {
    &:not(:last-child)::after {
      margin-left: 3.75rem;
    }
  }
`

export const Footnote = styled.div`
  margin-top: ${space['spacing-xl']};

  p {
    margin: 0;
  }

  @media (${media.desktop}) {
    margin-top: 3.125rem;
  }
`
